import { formatPhone } from './intake';

/**
 * Normalizes a phone string to a dialable tel: href value.
 *
 * Strips non-digits, accepts optional leading US "1", requires exactly
 * 10 remaining digits. Returns "+1XXXXXXXXXX" or null if invalid.
 *
 * Why: stored phones vary in format ("(555) 123-4567", "555-123-4567",
 * "+1 555.123.4567") but tel: links need a normalized E.164-ish form.
 */
export function toDialablePhone(
  value: string | null | undefined
): string | null {
  if (!value) return null;

  let digits = value.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }

  if (digits.length !== 10) return null;
  return `+1${digits}`;
}

export function formatDialablePhoneText(value: string): string {
  return formatPhone(value);
}
